import React from "react"

export function BotegaLogoSmall(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="25"
      height="25"
      viewBox="-30 -30 252 252"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.5865 141.687V125.121C8.32154 125.121 0 132.537 0 141.687V186.367C0 195.517 8.32154 202.933 18.5865 202.933H134.18C169.216 202.933 197.537 177.6 197.537 146.463C197.537 115.227 169.104 89.9935 134.095 89.9935V106.56C158.877 106.56 178.95 124.41 178.95 146.463C178.95 168.467 158.933 186.367 134.18 186.367H18.5865V141.687Z"
        fill="var(--mui-palette-text-primary)"
      />
      <path
        d="M92.2386 163.049L105.381 174.763L151.778 133.409L105.388 91.9753L92.2317 103.677L117.167 125.948L18.5865 125.121V141.687L116.237 141.659L92.2386 163.049Z"
        fill="var(--mui-palette-text-primary)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M138.137 82.0163C163.565 82.0163 184.147 63.6714 184.147 41.0081C184.147 18.3446 163.565 0 138.137 0H18.5865C8.32145 0 0 7.41686 0 16.566V103.006H18.5865V16.566H138.137C153.3 16.566 165.561 27.4939 165.561 41.0081C165.561 54.5222 153.3 65.4503 138.137 65.4503V82.0163Z"
        fill="var(--mui-palette-text-primary)"
      />
      <path
        d="M87.1071 44.013L73.9645 32.299L27.4697 73.7395L73.9714 115.099L87.1002 103.372L63.0887 82.0163H138.137V65.4503H63.0552L87.1071 44.013Z"
        fill="var(--mui-palette-text-primary)"
      />
      {/* <path
        d="M821.107 160.212H849.036H863V174.119V201.934H821.107V181.073V170.642V160.212Z"
        fill="#0DBD29"
      /> */}
    </svg>
  )
}
